<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-3">
            <!-- Start:: Is Active -->
            <div class="lg:tw-col-span-2">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="success"
              ></v-checkbox>
            </div>
            <!-- End:: Is Active -->
            <!-- Start:: Image -->
            <uplode-image
              :data_src="data.image"
              @inputChanged="uplodeImg_1"
              placeHolder="صورة المدير"
              class="lg:tw-col-span-2"
            ></uplode-image>
            <!-- End:: Image -->

            <!-- Start:: Name -->
            <div class="">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.fullname"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name") }}
                </label>
              </div>
            </div>
            <!-- End:: Name -->

            <!-- Start:: Phone -->
            <div class="">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.phone"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.phone") }}
                </label>
              </div>
            </div>
            <!-- End:: Phone -->

            <!-- Start:: Email -->
            <div class="">
              <div class="input_wrapper top_label">
                <input
                  type="email"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.email"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.email") }}
                </label>
              </div>
            </div>
            <!-- End:: Email -->

            <!-- Start:: Password -->
            <div class="">
              <div class="input_wrapper top_label">
                <input
                  type="password"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.password"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.password") }}
                </label>
              </div>
            </div>
            <!-- End:: Password -->

            <!-- Start:: Password  Confirmation-->

            <div class="input_wrapper top_label">
              <input
                type="password"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.password_confirmation"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.confirmPassword") }}
              </label>
            </div>

            <!-- End:: Password  Confirmation-->

            <!-- Start:: Gender -->

            <div class="input_wrapper">
              <label class="form-label">
                {{ $t("forms.labels.gender") }}
              </label>
              <multiselect
                v-model="data.gender"
                :options="genders"
                label="name"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
              ></multiselect>
            </div>

            <!-- End:: Gender -->

            <!-- Start:: Gender -->
            <div class="">
              <div class="input_wrapper">
                <label class="form-label">
                  الدور
                </label>
                <multiselect
                  v-model="data.role_id"
                  :options="roles"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
                      <span class="option__title">
                        <strong>{{ option.ar.name }}</strong>
                      </span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <!-- End:: Gender -->
            <!-- Start:: Is Ban -->
            <div class="lg:tw-col-span-2">
              <v-checkbox
                @change="!data.is_ban ? (data.ban_reason = '') : ''"
                :label="$t('forms.labels.is_ban')"
                v-model="data.is_ban"
                color="success"
              ></v-checkbox>
            </div>
            <!-- End:: Is Ban -->

            <!-- Start:: Ban Reason -->
            <div
              class="input_wrapper lg:tw-col-span-2"
              v-if="data.is_ban"
              :class="{ disabled: !data.is_ban }"
            >
              <label for="textarea_1" class="form-label">
                {{ $t("forms.labels.ban_reason") }}
              </label>
              <textarea
                v-model="data.ban_reason"
                class="form-control"
                rows="5"
              ></textarea>
            </div>
            <!-- End:: Ban Reason -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Edit",
  props: ["id"],
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.admins.title"),
          disabled: false,
          href: "/admins/show-all",
        },
        {
          text: this.$t("breadcrumb.admins.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        image: null,
        fullname: null,
        role_id: null,
        ban_reason: null,
        phone: null,
        is_ban: null,
        is_active: null,
        gender: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
      roles: [],
      // ========== Select Lists Data
      countries: [],
      cities: [],
      genders: [
        {
          id: "male",
          name: "ذكر",
        },
        {
          id: "female",
          name: "أنثي",
        },
      ],
    };
  },

  methods: {
    // ============ Get Select Lists Data
    // ============ Get Select Lists Data
    getRoles() {
      this.axios({
        method: "GET",
        url: `role`,
      }).then((res) => {
        this.roles = res.data.data;
      });
    },
    getData() {
      this.axios({
        method: "GET",
        url: `admin/${this.id}`,
      }).then((res) => {
        this.data = res.data.data;
        this.data.role_id = res.data.data.role;

        this.data.gender = this.genders.find(
          (el) => el.id == res.data.data.gender
        );
      });
    },
    // Uplode Image
    uplodeImg_1(obj) {
      this.data.image = obj;
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.image"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.fullname) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phone) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length < 9) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اكبر من 9 ارقام",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length > 11) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اقل من 11 رقم",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.email) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.email"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.role_id) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أختر دور",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.gender) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.gender"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.password_confirmation != this.data.password) {
        this.$iziToast.error({
          timeout: 2000,
          message: "كلمة السر وتأكيد كلمة السر غير متطابقين",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.is_ban && !this.data.ban_reason) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.ban_reason"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      if (this.data.image.img_file) {
        submit_data.append("image", this.data.image.img_file);
      }
      submit_data.append("fullname", this.data.fullname);
      submit_data.append("phone", this.data.phone);
      submit_data.append("email", this.data.email);
      submit_data.append("role_id", this.data.role_id.id);
      // submit_data.append('phone_code', this.data.phone_code)
      submit_data.append("gender", this.data.gender.id);
      if (this.data.password && this.data.password_confirmation) {
        submit_data.append("password", this.data.password);
        submit_data.append(
          "password_confirmation",
          this.data.password_confirmation
        );
      }
      submit_data.append("_method", "PUT");
      submit_data.append("is_ban", +this.data.is_ban);
      submit_data.append("is_active", +this.data.is_active);
      if (this.data.is_ban) {
        submit_data.append("ban_reason", this.data.ban_reason);
      }

      this.axios({
        method: "POST",
        url: `admin/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/admins/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  created() {
    // Start:: Fire Methods
    this.getRoles();
    this.getData();
    // End:: Fire Methods
  },
};
</script>
